import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { faAngleDown,faAngleUp,faPlusCircle, faSearch, faClipboard, faRefresh } from '@fortawesome/free-solid-svg-icons';
import * as commonConstant from '../../../../../services/common.constant';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from './../../../../../../../src/app/services/Users/manage-user/user.service';
import { NotificationService } from './../../../../../../../src/app/notification.service';
import * as CommonFunction from './../../../../../../../src/app/services/common.function';
import { NgxSpinnerService } from "ngx-spinner";
import { IpServiceService } from '../../../../../ip-service.service';
import { LoginService } from '../../../../../services/Authetication/login.service';
import { DatatransferService } from '../../../../../services/DataTransfer/datatransfer.service';
import { ClientService } from 'src/app/services/Client/client.service';
import { TeamService } from 'src/app/services/Teams/team.service';
import * as moment from 'moment';
import { Observable, Subscription, of, concatMap, merge } from 'rxjs';
import { ModulesService } from '../../../../../services/Authetication/menu-permission/modules.service'

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.css']
})
export class UserlistComponent implements OnInit, OnDestroy {
  @Input() clientStatus!: any;
  private userServiceSubscription!: Subscription;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faPlusCircle = faPlusCircle;
  faClipboard = faClipboard;
  faSearch = faSearch;
  faRefresh = faRefresh;
  listingBodyParameter: any;
  perPageArray: any[] = [];
  getModulesResponse:any[] = [];
  roles:any[] = [];
  getUserRole: any;
  teams: any;
  totalUsers:any;
  upName = false;
  downName = false;
  upEmail = false;
  downEmail = false;
  upContact = false;
  downContact = false;
  upStatus = false;
  downStatus = false;
  upUserType = false;
  downUserType = false;
  upTeam = false;
  downTeam = false;
  upCreationDate = false;
  downCreationDate = true;
  upLastSeen = false;
  downLastSeen = false;
  isShow = false;
  isClientUsers = true;
  isActiveSearch = false;
  selectedRow!: Number;
  isHover = false;
  userId!: string | undefined;
  selectedRowForArrow: Number | null | undefined;
  uId!: string;
  userName !: string;
  userRole !: string;
  userEmail !: string;
  userContact !: string;
  ipAddress: any;
  loginWithResponse: any;
  loginResponse: any;
  loCurrentUserData: any;
  viewClientId: any;
  getModulesResponseLength: any;
  loCurrentUserRoleData: any;
  loadingDataMessage = "Getting data..."
  currentViewClientExpiryDate: any
  isClientExpired = false;
  isClientActive: any ;
  stClient: any;
  buttonDisabled: boolean = false;
  teamResponse: any = [];
  // for team listing
  listingBodyParameterTeamListing: any
  @Input() isWebPageToggleEnabled: boolean = false;
  @Output() loaded = new EventEmitter<void>();
  @Output() webPageToggle  = new EventEmitter<boolean>();
  constructor(private _querystring: ActivatedRoute,
    private _Router: Router,
    private _userService: UserService,
    private _notificationService: NotificationService,
    private _modalService: NgbModal,
    private config: NgbModalConfig,
    private spinner: NgxSpinnerService,
    private _ipServiceService: IpServiceService,
    private _loginService: LoginService,
    private _dataService: DatatransferService,
    private _clientService: ClientService,
    private _teamService: TeamService,
    private _modulesService: ModulesService)
    {
      config.backdrop = 'static';
      config.keyboard = false;
      this.viewClientId = this._querystring.snapshot.paramMap.get('clientId');
      this.listingBodyParameter = commonConstant.listingBodyParameterForUser;
      this.listingBodyParameter.stSearchText = '';
      this.listingBodyParameter.stSortColumn = 'LastSeen';
      this.listingBodyParameter.inOffset = 0;
      this.perPageArray = commonConstant.perPageArray;

      this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
      this.loCurrentUserRoleData = JSON.parse(localStorage.getItem('LoggedInRole') || '{}');
      this.isClientActive = localStorage.getItem('isClientActive');

      // for team listing
      // Security hotfix HF-03 (FE-5): copy the shared request so other screens' values do not leak in
      this.listingBodyParameterTeamListing = { ...commonConstant.listingBodyParameterForTeam };
      this.listingBodyParameterTeamListing.stSortColumn = 'stName';
      this.listingBodyParameterTeamListing.stSortOrder = 'desc';
      this.listingBodyParameterTeamListing.stSearchText = '';
   }

  ngOnInit(): void {
    this.getIP();
    this.getRoleByRoleId();
    setTimeout(() => this.totalUsers = 0, 0);
    this._dataService.userLisingMessage.subscribe(UsersData => {
      if (UsersData != "" && UsersData != null && UsersData != undefined) {
        this.getModulesResponse = [];
        this.getModulesResponse = UsersData;
        const CurrentDate = moment(new Date()).format("MM/DD/YYYY");
        const ClientExpiredDate = moment(new Date(localStorage.getItem('currentViewClientExpiryDate') || '{}')).format("MM/DD/YYYY");
        this.stClient = localStorage.getItem('ViewClienName');
        if ((new Date(CurrentDate) > new Date(ClientExpiredDate)) && (new Date(CurrentDate) != new Date(ClientExpiredDate))) {
          this.isClientExpired = true;
        } else {
          this.isClientExpired = false;
        }
      }
    });
    this._dataService.teamLisingMessage.subscribe(TeamData => {
      this.teams = [];
      if (TeamData && Array.isArray(TeamData) && TeamData.length > 0) {
          this.teams = TeamData.map((teamInfo: any) => ({
          uiTeamId: teamInfo.teamId,
          stName: teamInfo.name
        }));
      }
    });

  }

  ngOnDestroy() { // unsubscribe to ensure no memory leaks
    if(this.userServiceSubscription) {
    this.userServiceSubscription.unsubscribe();
    }
    this._modalService.dismissAll("");
  }

  getIP() {
    // this._ipServiceService.getIPAddress().subscribe((res: any) => {
    //   //this.ipAddress = res.IPv4;
    //   this.ipAddress = res.ip;
    // });
     this._ipServiceService.getIPAddress().subscribe({
          next:(data:any) => {
            if (this.ipAddress == undefined || this.ipAddress == "") {
              //this.ipAddress = data.IPv4;
              this.ipAddress = data.ip;
              this.getIP();
            }
          },
          error:(error) => {
            console.log("Promise rejected with " + JSON.stringify(error));
          //this.getIPAddress();
          this.ipAddress = "1::1"
          }
    
        })
  }

    getRoleByRoleId(callback?: () => void) {
      this.spinner.show();
      this._modulesService.getRoleByRoleId(this.loCurrentUserData.roleId).subscribe({
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.getUserRole = response.data.role;
              if (response.data.role.name.toLowerCase() == "client admin") {
                this.listingBodyParameter.uiCLientId = this.loCurrentUserData.clientId;
                this.listingBodyParameterTeamListing.uiClientId = this.loCurrentUserData.clientId;
                this.viewClientId = this.loCurrentUserData.clientId;
                this.isClientUsers = true;
              }
              else {
                this.viewClientId = this._querystring.snapshot.paramMap.get('clientId');
                this.listingBodyParameterTeamListing.uiClientId = this._querystring.snapshot.paramMap.get('clientId');
                this.listingBodyParameter.uiCLientId = this.viewClientId;
              }

              if(!this.viewClientId){
                this.viewClientId = this.listingBodyParameter.uiCLientId = this.loCurrentUserData.clientId;
              }
              // Security hotfix HF-03 (FE-5): Team calls must name a client, falling back to the user's own
              this.listingBodyParameterTeamListing.uiClientId = this.viewClientId;
              this.getUsers();
              this.getRoles();              
            }
          }
          if(callback) callback();
        },
        error: (error) => {
          if (error != undefined) {
            if (error.status == 401) {
              //localStorage.setItem("Unauthorized", "true")
              //this._notificationService.showInfo("Your token is wrong or expired, you should log in again in the web portal.", "Information");
              this._Router.navigate(['login']);
              if(callback) callback();
            }
            else {
              this.getUsers();
            }
          }
          //this.getUsers();
        }
      }
      );
    }

    removeFilter(event:any){
      if ((event.key === 'Delete' || event.key==='Backspace') && event.target.value.length === 0 ) {
        this.clearFilter();
      }
    }

    updateUserStatus(clientId: any, userId: any, inStatus: any) {
    this.spinner.show();
    this.stClient = localStorage.getItem('ViewClienName');
    this._userService.updateUserStatus(null, userId, this.stClient, inStatus).subscribe(
      {
        next: (response) => {
          if (!!response) {
            this.spinner.hide();
            this._modalService.dismissAll("");
            if (response?.statusCode == 200) {
              if (inStatus === 1){
                const userObj = this.getModulesResponse.find((user: any) => user.userId === userId);
                if (userObj) userObj.status = 'Active';
                this._notificationService.showSuccess("Request has been approved.", "Success");
              } else{
                this.getModulesResponse = this.getModulesResponse.filter((user: any) => user.userId !== userId);
                this._notificationService.showSuccess("Request has been declined.", "Success");
              }
            } else{
              this._notificationService.showError("Something went wrong, please try again.", "Information");
            }}
          },
        error: (error) => {
          this.spinner.hide();
          this._modalService.dismissAll("");
          this._notificationService.showError("Something went to wrong please try again.", "Information");
        }
      });
  }

    showApprovalModal(content: any, user: any) {
      if(this.isClientActive != 'Pendingapproval'){
        this.userName = user.stName;
      this.userRole = user.userType;
      this.userEmail = user.email;
      this.userContact = user.contact;
      this.userId = user.userId;
      this._modalService
        .open(content, { backdrop: 'static', keyboard: false, centered: true, ariaLabelledBy: 'modal-basic-title', windowClass: 'ApprovalModal' })
        .result.then(
          (result) => {

          },
          (reason) => {

          }
        );
      }
    }

    clearFilter() {
      this.isActiveSearch = false;
      this.listingBodyParameter.stSearchText = "";
      this.getUsers();
    }

    activeSearch() {
      this.isActiveSearch = !this.isActiveSearch; //true;
      if (!this.isActiveSearch) {
        if (this.listingBodyParameter.stSearchText != "") {
          this.isActiveSearch = false;
          this.listingBodyParameter.inOffset = 0;
          this.getUsers();
        }
      }
    }

    getUsers(callback?: () => void) {
        this.userServiceSubscription = this._userService.getUpdate().subscribe
        (obj => { //obj contains the data sent from service
        this.getModulesResponse = obj;
        });
      this.loadingDataMessage = "Getting data..."
      this.listingBodyParameter.TimeZone = CommonFunction.GetTimeZone();
      this._userService.getUsers(this.listingBodyParameter).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this.getModulesResponse = [];
                this.getModulesResponse = response.data.resultSet;
                this.isWebPageToggleEnabled = response.data.resultSet[0].isWebPageToggleEnabled;
                // if(this.loCurrentUserData.roleId.toLowerCase() == 'e8921831-15b5-496d-9dcb-f75232ccea08'){
                //   this.getModulesResponse = response.data.resultSet.filter((x : any) => x.roleId.toLowerCase() != '8ed4fdbb-6b85-4d05-be1b-27187e635544')
                // }
                this.getModulesResponseLength = this.getModulesResponse.length;
                var CurrentDate: any;
                // CurrentDate = new Date(moment(new Date()).utc().utcOffset('-06:00').format("YYYY-MM-DD")); //new Date(moment(new Date()).format('MM/DD/YYYY'));
                CurrentDate = new Date(moment(new Date()).format('MM/DD/YYYY'));
                CurrentDate.setHours(0)
                CurrentDate.setMinutes(0)
                CurrentDate.setMilliseconds(0)
                this.currentViewClientExpiryDate = new Date(this.loCurrentUserData.clientExpiration);
                if(this.loCurrentUserData.isSuperAdmin == true){
                  this.isClientExpired = false;
                }
                else if((CurrentDate > this.currentViewClientExpiryDate)) {
                  this.isClientExpired = true;
                } else {
                  this.isClientExpired = false
                }
                setTimeout(() => {
                  if (this.getModulesResponse && this.getModulesResponse.length) {
                    this.totalUsers = this.getModulesResponse[0].totalRecords;
                  }
                }, 900);
                setTimeout(() => {
                  this.loaded.emit(); // Notify parent when loaded
                }, 1000);
              };
            }
            if(callback) callback();
          },
          error: (error) => {
            // this.getModulesResponse = {
            //   resultSet: []
            // };
            this.spinner.hide();
            this.getModulesResponse = [];
            this.totalUsers = 0;
            this.loadingDataMessage = "No data found"
            setTimeout(() => this.totalUsers = 0, 0);
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError('Internal server error', 'Error');
            }
            if(callback) callback();
          }
        }
      );
    }

    pageChanged(event: number) {
      this.listingBodyParameter.inOffset = event - 1;
      this.getUsers();
    }

    changePageLimit(pageLimit: any) {
      this.listingBodyParameter.inOffset = 0;
      this.listingBodyParameter.inLimit = parseInt(pageLimit);
      this.getUsers();
    }

    sort(field: string, order: any): void {
      this.listingBodyParameter.stSortColumn = field;
      this.listingBodyParameter.stSortOrder = order;
      this.getUsers();
    }

    searchData() {
      this.listingBodyParameter.inOffset = 0;
      this.getUsers();
    }

    makeActiveInactive(field: string, order: any): any {
      this.upName = false;
      this.downName = false;
      this.upEmail = false;
      this.downEmail = false;
      this.upContact = false;
      this.downContact = false;
      this.upStatus = false;
      this.downStatus = false;
      this.upUserType = false;
      this.downUserType = false;
      this.upTeam = false;
      this.downTeam = false;
      this.upCreationDate = false;
      this.downCreationDate = false;
      this.upLastSeen = false;
      this.downLastSeen = false;
      if (field == 'stName') {
        if (order == 'asc') {
          this.upName = true;
        } else {
          this.downName = true;
        }
      }
      else if (field == 'Email') {
        if (order == 'asc') {
          this.upEmail = true;
        } else {
          this.downEmail = true;
        }
      }
      else if (field == 'PhoneNumber') {
        if (order == 'asc') {
          this.upContact = true;
        } else {
          this.downContact = true;
        }
      }
      else if (field == 'Status') {
        if (order == 'asc') {
          this.upStatus = true;
        } else {
          this.downStatus = true;
        }
      }
      else if (field == 'name') {
        if (order == 'asc') {
          this.upUserType = true;
        } else {
          this.downUserType = true;
        }
      }
      else if (field == 'stTeam') {
        if (order == 'asc') {
          this.upTeam = true;
        } else {
          this.downTeam = true;
        }
      }
      else if (field == 'dtCreatedOn') {
        if (order == 'asc') {
          this.upCreationDate = true;
        } else {
          this.downCreationDate = true;
        }
      }
      else if (field == 'LastSeen') {
        if (order == 'asc') {
          this.upLastSeen = true;
        } else {
          this.downLastSeen = true;
        }
      }
    }

    // Open actions buttons to left
    setClickedRow =  (index:any, isHover:any) => {
      if (this.selectedRow == undefined || index != this.selectedRow || (index == this.selectedRow && !isHover)) {
        this.isHover = true;
        this.selectedRow = index;
      } else if (index == this.selectedRow && isHover) {
        this.isHover = false;
        this.selectedRow = -1;
      }
    }

    // Open actions buttons to left
    setClickedRowForArrow =  (index:number) => {
      if (index != this.selectedRowForArrow) {
        this.selectedRowForArrow = -1;
        this.selectedRowForArrow = index;
      }
      else {
        this.selectedRowForArrow = -1;
      }
    }

    // Hide Modal
    hideModal() {
      this._modalService.dismissAll("");
    }

    showModal(content: any, userId: any, action: any) {
      const isClientActive = this.clientStatusValidation();
      if (!isClientActive) {
        return;
      }
      if (userId == null) {
        this.userId = undefined;
      }
      localStorage.setItem('userAddEditAction', JSON.stringify(action));
      if(this.isClientActive == 'Pendingapproval'){
        this.buttonDisabled = true;
       }else{
        this.buttonDisabled = false;
        this._modalService
        .open(content, userId)
        .result.then(
          (result: any) => {
            // this.closeResult = `Closed with: ${result}`;
          },
          (reason: any) => {
            // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          }
        );
       }
    }

    // Update user starts
    onUpdateUser(content: any, userId: any, status: any, action: any) {
      this.userId = userId;
      let expieddate:any  = localStorage.getItem('currentViewClientExpiryDate');
      const ClientExpiredDate = moment(new Date(expieddate)).format("MM/DD/YYYY");
      const CurrentDate = moment(new Date()).format("MM/DD/YYYY");
      // if(status == 'Inactive'){
      //   this._notificationService.showError('Your account is not active, please contact administrator', "Error");
      //   return;
      // }
      this.showModal(content, userId, action);
      // if(this.isClientActive == 'Active')
      // {
      //   if ((new Date(ClientExpiredDate) > new Date(CurrentDate)) && (new Date(CurrentDate) != new Date(ClientExpiredDate))) {
      //     this.spinner.show();
      //   }
      // }
      setTimeout(() => {
        this.spinner.hide()
      }, 2000);
    }
    // Update User Ends


    // Archive user starts
    showArchiveAlert(content:any, userId:any) {
      this.uId = userId;
      this._modalService
        .open(content, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {

          },
          (reason) => {

          }
        );
    }

    archive(userId:any) {
      this.spinner.show();
      this._userService.archiveUser(userId).subscribe(
        {
          next: response => {
            if (!!response) {
              this._notificationService.showSuccess(response.message, "Success");
              this._dataService.sendDataBetweenComponentsForUpdateTeamList(true);
              of(1).pipe(
                concatMap(() => new Observable(observer => this.getTeams(() => {observer.next(); observer.complete();}))),
                concatMap(() => merge(
                  new Observable(observer => {
                    this.getClientDetails(() => { observer.next(); observer.complete(); });
                  }),
                  new Observable(observer => {
                    this.getUserByEmail(() => { observer.next(); observer.complete(); });
                  }),
                  new Observable(observer => {
                    this.getUsers(() => { observer.next(); observer.complete(); });
                  })
                ))).subscribe({
                  complete: () => {
                  this.spinner.hide();
                }
              });
              this.hideModal();
            }
          },
          error: (error) => {
            if (error != undefined) {
              if (error.status == 401 && error.statusText == "Unauthorized") {
                this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
              }
              else if (error.status == 0) {
                this._notificationService.showError(error.message, "Error"); // unknown error
              }
            }
            this.spinner.hide();
          }
        });
    }
    // Archive user ends

    getClientDetails(callback?: () => void) {
      let dt = {
        clientId: this.listingBodyParameter.uiCLientId,
        stSearchText: "",
        stSortColumn: "stClient",
        stSortOrder: "",
        inOffset: 0,
        inLimit: 0
      };

      this._clientService.viewClient(dt).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this._dataService.sendDataBetweenComponentsCLientViewPageCounts(response.data.resultSet[0]);
                this.isClientActive = response.data.resultSet[0].isActive;
                if(this.isClientActive == 'Pendingapproval'){
                  this.buttonDisabled = true;
                 }else{
                  this.buttonDisabled = false;
                 }
              }
            }
            if(callback) callback();
          },
          error: (error) => {
            if(callback) callback();
          }
        });
    }

    getRoles() {
      this._userService.getRoles().subscribe(
        {
          next: (response) => {
            if (!!response) {
              this.roles = response.roles.filter((t: { name: string; }) => t.name.toLowerCase() != 'super admin');
            }
          },
          error: (error) => {
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
          }
        });
    }

    getTeams(callback?: () => void) {
    // Security hotfix HF-03 (FE-5): list every team of the client
    this.listingBodyParameterTeamListing.teamId = null;
    this._teamService.getTeams(this.listingBodyParameterTeamListing).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this._dataService.sendDataBetweenComponentsForTeamListing(response.data.resultSet);
            }
          }
          if(callback) callback();
        },
        error: (error) => {
          this.teamResponse = [];
          this._dataService.sendDataBetweenComponentsForTeamListing(this.teamResponse);
          if(callback) callback();
        }
      });
  }

  // User History starts
  getUserHistory(userId:any, userType:any) {
    //this._Router.navigate(['user/history/' + userId]);
    this._Router.navigate(['/history/' + userId + '/user']);
  }
  // User History ends

  // User Login History starts
  getUserLoginHistory(userId:any) {
    this._Router.navigate(['user/loginhistory/' + userId]);
  }
  // unLock User Account starts
  unLockUserAccount(userId:any) {
    this.spinner.show();
    this._userService.unLockUserAccount(userId).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if(response.statusCode == 200){
              this._notificationService.showSuccess(response.data,"Success");
              this.getUsers();
              this.spinner.hide();
            }
          }
        },
        error:  (error) => {
          this.spinner.hide();
          this._notificationService.showError("Something went to wrong please try again.","Information");
        }
      });
  }
  // unLock User Account ends

  // User Login With starts
  loginWith(userId:any) {
    const isClientActive = this.clientStatusValidation();
      if (!isClientActive) {
        return;
      }
      if(this.isClientActive == 'Pendingapproval'){
       this.buttonDisabled = true;
      }else{
       this.buttonDisabled = false;
      }

    this.loCurrentUserData = JSON.parse(localStorage.getItem('currentUserData') || '{}');
    if (userId != this.loCurrentUserData.userId) {
      this.spinner.show();
      this.ipAddress = this.ipAddress;
      var userIds = localStorage.getItem('SuperAdminUserId') || '00000000-0000-0000-0000-000000000000';
      this._loginService.loginWith(userId, this.ipAddress, true, userIds).subscribe(
        {
          next: (response: any) => {
            if (!!response) {
              this.spinner.hide();
              if (response.statusCode == 200) {
                this.loginWithResponse = response.data;
                if (this.loginWithResponse.clientFlgIsActive || this.loginWithResponse.isSuperAdmin || this.loginWithResponse.isClientAdmin) {
                   localStorage.setItem('currentUserData', JSON.stringify(this.loginWithResponse));
                   localStorage.setItem('LoginwithcurrentUserData', JSON.stringify(this.loginWithResponse));
                   localStorage.setItem('LoginwithflgIsLoggedInAsUser', "1");
                  setTimeout(() => {
                    this._dataService.sendDataBetweenComponents(this.loginWithResponse);
                  }, 2000);
                  this.getLoginUserRole(this.loginWithResponse);
                  if (this.loginWithResponse.isFlgIsClientExpired == true && !this.loginWithResponse.isSuperAdmin) {
                    this._Router.navigate(["client/expiration"]);
                  }
                  else {
                    this.afterLoginRedirect(this.loginWithResponse);
                  }
                }
                else {
                  this._notificationService.showError('Your client has been inactive, please contact to administrator', "Error");
                }
                this.spinner.hide();
              }
            }

          },
          error: (error) => {
            this.spinner.hide();
            this.loginWithResponse = {
              resultSet: []
            };
            if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            }
            else if (error.status == 500) {
              this._notificationService.showError("Internal Server Error.", 'Error');
            }
            else{
              this._notificationService.showError(error.error.errorMessage, 'Error');
            }
          }
        } );
    }

  }
  // User Login With ends

  // To revoke 2FA
  getRevoke2FA(uiUserId: any) {
    const isClientActive = this.clientStatusValidation();
      if (!isClientActive) {
        return;
      }
    this.spinner.show();
    this._userService.revoke2FA(uiUserId).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if(response.statusCode == 200){
              this._notificationService.showSuccess("Revoked 2FA successfully","Success");
              this.spinner.hide();
            }
          }
        },
        error:  (error) => {
          this.spinner.hide();
          if (error.status == 0) {
            this._notificationService.showError(error.message, 'Error'); // unknown error
          }
          else if (error.status == 500) {
            this._notificationService.showError("Internal Server Error.", 'Error');
          }
          else{
            this._notificationService.showError(error.error.errorMessage, 'Error');
          }
        }
      });
  }

  getLoginUserRole(data: any) {
    this._modulesService.AfterLogin(data).subscribe(
      {
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              localStorage.setItem('LoggedInRole', JSON.stringify(response.data));
            }
          }
        },
        error:  (error) => {
        }
      });
  }

  afterLoginRedirect(data: any) {
    this._modulesService.AfterLogin(data).subscribe(
      {
        next: (response: any) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.spinner.hide();
              localStorage.setItem('LoggedInRole', JSON.stringify(response.data));
              if (!data.isflgIsSetupPassword) {
                // this._Router.navigate(['profile-setting']);
                //localStorage.removeItem('currentUserData');
                //localStorage.setItem('currentUserData', JSON.stringify(this.loginWithResponse));
                window.location.href = 'setnewpassword'
              }
              else {
                  localStorage.removeItem('currentUserData');
                  localStorage.setItem('currentUserData', JSON.stringify(this.loginWithResponse));
                  localStorage.setItem('flgIsLoggedInAsUser', "1");

                if (response.data.role.name.toLowerCase() == "super admin") {
                  // this._Router.navigate(['utilization']);
                  window.location.href = 'utilization'
                }
                else if (response.data.role.name.toLowerCase() == "client admin") {
                  // this._Router.navigate(['utilization']);
                  //this.checkMenuAccess(data, 'parameters');
                  this.checkMenuAccess(data, 'utilization');
                }
                else if (response.data.role.name.toLowerCase() == "user") {
                  this.checkMenuAccess(data, 'requests');
                }
                else if (response.data.role.name.toLowerCase() == "report reviewer" 
                || response.data.role.name.toLowerCase() == "approver" 
                || response.data.role.name.toLowerCase() == "publisher") {
                  this.checkMenuAccess(data, 'workbench');
                }
                else {
                  this.checkMenuAccess(data, 'requests')
                }
              }
            }
          }
        },
        error: (error) => {
          this.spinner.hide();
          this._notificationService.showError(error.message, 'Error');
        }
      });
  }

  checkMenuAccess(data: any, url:any) {
    this._modulesService.checkMenuAccess(data).subscribe(
      (response: any) => {
        if (!!response) {
          if (response.statusCode == 200) {
            var isPresent = response.data.modules.some(function (el:any) {
              return el.stRouterLink === url
            });
            if (isPresent) {
              window.location.href = url;
              this._Router.navigate([url]);
            }
            else {
              this._Router.navigate([url]);
              //window.location.href = response.data.modules[0].stRouterLink; // comment on 26/07/2022
            }
          }
        }
      }, (error) => {
        this.spinner.hide();
      });
  }

  generateToken(UserId:any) {
    this.spinner.show();
    this._userService.GenerateAPIAccessToken(UserId, this.viewClientId).subscribe(
      {
        next: (response) => {
          if (!!response) {
            if(response.statusCode == 200){
              this._notificationService.showSuccess(response.message,"Success");
              this.getUsers();
              this.spinner.hide();
            }
          }
        },
        error:  (error) => {
          this.spinner.hide();
          this._notificationService.showSuccess("Something went to wrong please try again.","Information");
        }
      });
  }

  copyToken(val: string){
    let textarea = null
    textarea = document.createElement('textarea');
      textarea.style.position = 'fixed';
      textarea.style.left = '0';
      textarea.style.top = '0';
      textarea.style.opacity = '0';
      textarea.value = val;
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }


    getUserByEmail(callback?: () => void) {
      let clientId = this.viewClientId;
      let searchText = ""
      this._teamService.getUserByEmail(this.viewClientId, searchText).subscribe(
        {
          next: (response) => {
            if (!!response) {
              if (response.statusCode == 200) {
                this._dataService.sendDataBetweenComponentsForTeamMember(response.data.users);
              }
            }
            if(callback) callback();
          },
          error: (error) => {
            if(callback) callback();
          }
        });
    }

    clientStatusValidation() {
    this.isClientActive = localStorage.getItem('isClientActive');
    let expiredDate:any  = localStorage.getItem('currentViewClientExpiryDate');
    const clientExpiredDate = moment(new Date(expiredDate)).format("MM/DD/YYYY");
    const currentDate = moment(new Date()).format("MM/DD/YYYY");
      if((this.isClientActive == 'Inactive') || (new Date(currentDate) > new Date(clientExpiredDate)) && (new Date(currentDate) != new Date(clientExpiredDate))){
        this._notificationService.showError('Client is inactive or expired.', "Error");
        return false;
      }
      return true;
    }

    onWebPageToggle(newValue: boolean) {
      this.isWebPageToggleEnabled = newValue;
    }
}